export default __webpack_public_path__ + "static/media/logo.b5f6150f.png";